import { Report } from "interfaces";
import { Dialog } from "primereact/dialog";
import {
  ModalResolveReportPartiallyWrongBody,
  ModalResolveReportPartiallyWrongFooter,
  ModalResolveReportPartiallyWrongHeader,
} from "./components";

export const ModalResolveReportPartiallyWrong = ({
  showModal,
  report,
  onClose,
}: {
  showModal: boolean;
  report: Report;
  onClose: Function;
}) => {
  return (
    <Dialog
      id="modal-resolve-report"
      draggable={false}
      resizable={false}
      header={
        <ModalResolveReportPartiallyWrongHeader reportCode={report.code} />
      }
      visible={showModal}
      style={{
        height: 700,
        width: 1240,
      }}
      onHide={() => onClose()}
      dismissableMask={true}
      className="modal-resolve-report"
    >
      <ModalResolveReportPartiallyWrongBody report={report} onClose={onClose} />
      <ModalResolveReportPartiallyWrongFooter />
    </Dialog>
  );
};
